import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        const hash = window.location.hash;
        const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");
        if (!sessionId) throw new Error("No session id");
        const { data } = await axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true });
        setUser(data);
        // Clean the fragment and go to the portal
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/portal", { replace: true, state: { user: data } });
      } catch (error) {
        console.error("Auth callback failed:", error);
        navigate("/auth", { replace: true });
      }
    };
    processSession();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#EDF7F6] to-[#FAF9F6] flex items-center justify-center">
      <div className="flex items-center gap-3 text-primary">
        <Loader2 className="w-6 h-6 animate-spin" />
        <span className="text-lg font-body">Signing you in securely...</span>
      </div>
    </div>
  );
}
